// extracted by mini-css-extract-plugin
export default {"switcherContainer":"styles_switcherContainer__ZlSP2","active":"styles_active__6yb0p","inActive":"styles_inActive__ayBKM"};